module.exports = __webpack_public_path__ + "img/top-1-4.a7722fc5.jpg";